import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import {
	BookingRequestType,
	BookingUpdateRequestType,
	BookingsResponseType,
} from '@/types/booking';
import {
	CheckCarAccessRequestType,
	CheckCarAccessResponseType,
} from '@/types/car-access';
import { SecurityBookingsResponseType } from '@/types/security';

const bookingsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getObjectBookings: builder.query<BookingsResponseType, string>({
			query: () => ({
				url: ApiRoutes.Bookings,
			}),
			providesTags: ['Bookings'],
		}),
		createBooking: builder.mutation<BookingsResponseType, BookingRequestType>(
			{
				query: (body) => ({
					url: ApiRoutes.Bookings,
					method: 'POST',
					body,
				}),
				invalidatesTags: [
					'AvailableObjects',
					'PersonBookings',
					'SecurityBookings',
				],
			},
		),
		updateBooking: builder.mutation<
			BookingsResponseType,
			BookingUpdateRequestType
		>({
			query: ({ id, body }) => ({
				url: `${ApiRoutes.Bookings}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: [
				'AvailableObjects',
				'PersonBookings',
				'SecurityBookings',
			],
		}),
		deleteBooking: builder.mutation<BookingsResponseType, number>({
			query: (id) => ({
				url: `${ApiRoutes.Bookings}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: [
				'PersonBookings',
				'AvailableObjects',
				'SecurityBookings',
			],
		}),
		finishBooking: builder.mutation<BookingsResponseType, number>({
			query: (id) => ({
				url: `${ApiRoutes.Bookings}/${id}/finish`,
				method: 'PUT',
			}),
			invalidatesTags: [
				'PersonBookings',
				'AvailableObjects',
				'SecurityBookings',
			],
		}),
		getSecurityBookings: builder.query<SecurityBookingsResponseType, string>({
			query: () => ({
				url: `${ApiRoutes.Bookings}/for_moderator`,
			}),
			providesTags: ['SecurityBookings'],
		}),
		checkCarAccess: builder.query<
			CheckCarAccessResponseType,
			CheckCarAccessRequestType
		>({
			query: (params) => ({
				url: ApiRoutes.CarAccess,
				params,
			}),
		}),
	}),
	overrideExisting: false,
});

export const {
	useCreateBookingMutation,
	useDeleteBookingMutation,
	useFinishBookingMutation,
	useGetSecurityBookingsQuery,
	useUpdateBookingMutation,
	useLazyCheckCarAccessQuery,
} = bookingsApi;
